export default __webpack_public_path__ + "static/media/qrcode-signup.450ecdd1.svg";